/* @flow */

import {
  templateRoot,
  templateMain,
  templateContent,
  templateContainer,
  templateContentInner,
} from './style/template.style';
import { tablet } from '@braindate/ui/lib/token/mediaQuery';
import { REGULAR_SIDEBAR_WIDTH } from 'src/shared/app/base/component/template/component/sidebar/SideBar.style';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    extend: templateRoot,
  },

  main: {
    extend: templateMain,
    margin: '0 auto',

    [tablet]: {
      width: `calc(100% - ${REGULAR_SIDEBAR_WIDTH + 20}px)`,
    },
  },

  contentInner: {
    extend: templateContentInner,
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,
  },

  content: {
    extend: templateContent,
  },

  container: {
    extend: templateContainer,
  },
};
